import { FC } from 'react';

const IgnoreParentPadding: FC<{
  px: number;
  style?: React.CSSProperties;
  children: React.ReactNode;
}> = ({ px, style, children }) => {
  return (
    <div
      style={{
        width: `calc(100% + ${px}*2)`,
        margin: `0 -${px}px 0 -${px}px`,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default IgnoreParentPadding;
